import { ChevronRight } from "lucide-react"
import { leaveChatCopy } from "../config/chat-copy"

interface LeaveChatModalProps {
  isOpen: boolean
  onKeep: () => void
  onLeave: () => void
  /** Tapping a suggested question sends it and keeps the chat open. */
  onPreset: (preset: string) => void
}

export function LeaveChatModal({ isOpen, onKeep, onLeave, onPreset }: LeaveChatModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[110] flex items-end justify-center bg-[#3b322e70]">
      <div className="w-full max-w-app rounded-t-3xl bg-dark-surface p-4">
        <p className="text-center font-display text-2xl font-medium text-purple-light">
          {leaveChatCopy.title}
        </p>
        <p className="mt-2 text-center font-body text-base text-purple-light/70">
          {leaveChatCopy.subtitle}
        </p>

        <div className="my-4 flex flex-col gap-2">
          {leaveChatCopy.presets.map((q) => (
            <button
              type="button"
              key={q}
              onClick={() => onPreset(q)}
              className="flex items-center justify-between gap-2 rounded-xl bg-purple-light/10 px-4 py-3 text-left font-body text-base text-purple-light"
            >
              {q}
              <ChevronRight className="size-5 shrink-0 text-purple-light/70" />
            </button>
          ))}
        </div>

        <button
          type="button"
          onClick={onKeep}
          className="h-14 w-full rounded-[80px] bg-gradient-to-b from-peach to-purple-accent font-body text-base font-semibold text-white"
        >
          {leaveChatCopy.keep}
        </button>
        <button
          type="button"
          onClick={onLeave}
          className="mt-2 h-12 w-full rounded-[80px] font-body text-base font-semibold text-purple-light/70"
        >
          {leaveChatCopy.leave}
        </button>
      </div>
    </div>
  )
}
